import styled from 'styled-components';

export const ContactItem = ({ title, icon, text, email }) => {
  return (
    <ContactItemStyled>
      <div className='left-content'>{icon}</div>
      <div className='right-content'>
        <h6>{title}</h6>
        <p>{email ? <a href={`mailto:${text}`}>{text}</a> : text}</p>
      </div>
    </ContactItemStyled>
  );
};

const ContactItemStyled = styled.div`
  padding: 1.5rem 2rem;
  background-color: var(--background-dark-grey);
  display: flex;
  align-items: center;
  &:not(:last-child) {
    margin-bottom: 2.5rem;
  }
  @media screen and (max-width: 786px) {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    &:not(:last-child) {
      margin-bottom: 1rem;
    }
  }
  .left-content {
    padding: 1.5rem;
    border: 1px solid var(--border-color);
    font-size: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1.5rem;
    svg {
      font-size: 2.3rem;
    }
    @media screen and (max-width: 786px) {
      border: none;
      padding: 1px 0;
      svg {
        font-size: 1.8rem;
      }
    }
  }
  .right-content {
    h6 {
      color: var(--white-color);
      font-size: 1.2rem;
      padding-bottom: 0.6rem;
    }
    p {
      padding: 0.1rem 0;
    }
    @media screen and (max-width: 786px) {
    }
  }
`;
